import pluginRegistry from '../plugin/PluginProvider';

export function isDieselReducer(plugin) {
    return (plugin && plugin.dieselReducerPlugin) || false;
}

export default function dieselReducer(name, target, bootstrap, clientBootstrap) {
    target.dieselReducerPlugin = true;
    target.bootstrap = bootstrap;
    target.reducerName = name;
    target.clientBootstrap = clientBootstrap;
    pluginRegistry.providePlugin(target);
}
